import { ActivatedRouteSnapshot, CanActivateChildFn, Router, RouterStateSnapshot } from '@angular/router';
import { ConfigService } from '../services/config.service';
import { inject } from '@angular/core';

export const taskGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const configService = inject(ConfigService);
  const router = inject(Router);

  const taskRequired = route.data['tasks'] as string[];
  const permissions = configService.getPermissions();

  if (taskRequired && taskRequired.length > 0) {
    const hasPermission = taskRequired.every(task => permissions?.[task]);
    if (!hasPermission) {
      router.navigate(['/pages']);
      return false;
    }
  }

  return true;
};
